import { render, staticRenderFns } from "./yundong.vue?vue&type=template&id=7236af2e&scoped=true&"
import script from "./yundong.vue?vue&type=script&lang=ts&"
export * from "./yundong.vue?vue&type=script&lang=ts&"
import style0 from "./yundong.vue?vue&type=style&index=0&id=7236af2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7236af2e",
  null
  
)

export default component.exports